import {
  componentNameValidationMixin,
  createStyleMixin,
  draggableMixin,
} from '@descope-ui/common/components-mixins';
import { createBaseClass } from '@descope-ui/common/base-classes';
import { getComponentName } from '@descope-ui/common/components-helpers';
import { compose } from '@descope-ui/common/utils';
import { injectStyle } from '@descope-ui/common/components-helpers';

export const componentName = getComponentName('badge');

class RawBadge extends createBaseClass({
  componentName,
  baseSelector: ':host > div',
}) {
  constructor() {
    super();

    this.attachShadow({ mode: 'open' }).innerHTML = `
		<div>
      <slot></slot>
		</div>
		`;

    injectStyle(
      `
      :host {
        display: inline-flex;
      }
      :host > div {
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      `,
      this,
    );
  }
}

export const BadgeClass = compose(
  createStyleMixin({
    mappings: {
      hostWidth: [{ selector: () => ':host', property: 'width' }],
      hostDirection: { property: 'direction' },

      fontFamily: {},
      fontSize: {},
      fontWeight: {},
      textTransform: {},
      verticalPadding: [
        { property: 'padding-top' },
        { property: 'padding-bottom' },
      ],
      horizontalPadding: [
        { property: 'padding-left' },
        { property: 'padding-right' },
      ],

      borderWidth: {},
      borderStyle: {},
      borderColor: {},
      borderRadius: {},

      backgroundColor: {},

      textColor: { property: 'color' },
      textAlign: {},
    },
  }),
  draggableMixin,
  componentNameValidationMixin,
)(RawBadge);
